import numberUtils from './numberUtils';
import store from '../store';
import loadingUtils from './numberUtils';
import { CONST } from '../constant';
import { fetchJoinedCommunities } from '../api/community';

export default {
  getHost() {
    return location.protocol + '//' + location.host;
  },
  // 本番ホスト判定。GA/AdSense は prod(commin.app)でのみ作動させ、stg/dev/ローカルが prod 解析(UA-115205170-2)を
  // 汚さない・stg で実広告を配信しないようにする（issue#35 stg 分離）。
  isProdHost() {
    return location.hostname === 'commin.app'
  },
  messageDateStr(time) {
    let moment = require('moment-timezone');
    let locale = store.state.user.lang;
    let timezone = store.state.user.timezone;
    let now = moment.tz(timezone).locale(locale);
    let yearFormat = 'Y'; // for check same year
    let dateFormat = 'Y-M-D'; // check is today
    let weekFormat = 'Y-ww'; // check is same week (week of year)
    let timeDate = moment
      .unix(time)
      .tz(timezone)
      .locale(locale);

    if (now.format(dateFormat) === timeDate.format(dateFormat)) {
      // is today
      return timeDate.format('HH:mm');
    } else if (now.format(weekFormat) === timeDate.format(weekFormat)) {
      return timeDate.format('ddd');
    } else if (now.format(yearFormat) === timeDate.format(yearFormat)) {
      return timeDate.format('MMM D');
    } else {
      return timeDate.format('Y/M/D');
    }
  },
  currentUTCtimestamp() {
    let moment = require('moment');
    return moment().unix();
  },
  getGmtOffset() {
    let now = new Date();

    let gmtOffet = -(now.getTimezoneOffset() / 60);
    let absOffset = Math.abs(gmtOffet);
    let fullOffset = absOffset < 10 ? '0' + absOffset : absOffset;

    return gmtOffet >= 0 ? '+' + fullOffset + ':00' : '-' + fullOffset + ':00';
  },

  getYearMonth(str) {
    let dt = new Date(str);
    // add '0' prefix for month, day if needed
    let month = dt.getMonth() + 1;
    month = month >= 10 ? month : '0' + month;

    return dt.getFullYear() + '-' + month;
  },

  getCurrentYearMonth() {
    let dt = new Date();
    // add '0' prefix for month, day if needed
    let month = dt.getMonth() + 1;
    month = month >= 10 ? month : '0' + month;

    return dt.getFullYear() + '-' + month;
  },

  // yyyy-MM-dd HH:mm:ss
  formatDatetimeDefault(str) {
    let dt = new Date(str);

    let year = dt.getFullYear();

    let month = numberUtils.convertToTwoCharacterType(dt.getMonth() + 1);

    let date = numberUtils.convertToTwoCharacterType(dt.getDate());

    let hour = numberUtils.convertToTwoCharacterType(dt.getHours());

    let minute = numberUtils.convertToTwoCharacterType(dt.getMinutes());

    let second = numberUtils.convertToTwoCharacterType(dt.getSeconds());

    return year + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + second;
  },
  // yyyy-MM-dd
  formatDateDefault(str) {
    let dt = new Date(str);

    let year = dt.getFullYear();

    let month = numberUtils.convertToTwoCharacterType(dt.getMonth() + 1);

    let date = numberUtils.convertToTwoCharacterType(dt.getDate());

    return year + '-' + month + '-' + date;
  },

  getDayOfMonth(str) {
    let dt = new Date(str);

    return numberUtils.convertToTwoCharacterType(dt.getDate());
  },

  getBrowserLanguage() {
    let lang = '';

    if (typeof navigator !== 'undefined') {
      if (navigator.languages) {
        lang = navigator.languages[0];
      } else if (navigator.userLanguage) {
        lang = navigator.userLanguage;
      } else if (navigator.language) {
        lang = navigator.language;
      }

      // en-US, en-xx will return en
      if (lang.match(/^en/)) {
        lang = lang.split('-')[0];
      }

      if (lang.match(/^zh/)) {
        lang = lang.replace('-', '_');
      }
    }

    return lang.length > 0 ? lang : undefined;
  },

  loadingStatus: {
    root: true,
    main: false,
  },
  isLoading() {
    return this.loadingStatus.root || this.loadingStatus.main;
  },
  startRootLoading() {
    if (this.loadingStatus.root || this.loadingStatus.main) {
      this.loadingStatus.root = true;
      return;
    }
    this.loadingStatus.root = true;
    $('#rootLoading').fadeIn();
  },
  startRootLoading(fast) {
    this.fadeIn($('#rootLoading'), $('#loading'), fast);
  },
  startLoading(fast) {
    this.fadeIn($('#loading'), $('#rootLoading'), fast);
  },
  fadeIn(target, other, fast) {
    if (target.hasClass('a') || other.hasClass('a')) {
      target.addClass('a');
      return;
    }
    target.addClass('a');
    target.removeClass('a');
    if (fast) {
      target.css('display', 'block');
    } else {
      target.fadeIn();
    }
  },
  stopRootLoading(fast) {
    this.fadeOut($('#rootLoading'), $('#loading'), fast);
  },
  stopLoading(fast) {
    this.fadeOut($('#loading'), $('#rootLoading'), fast);
  },
  fadeOut(target, other, fast) {
    if (other.hasClass('a')) {
      target.removeClass('a');
      return;
    }
    target.removeClass('a');
    if (fast) {
      target.css('display', 'none');
    } else {
      target.fadeOut();
    }
  },

  setDocumentTitle(to, community, title) {
    if (title) {
      document.title = to.meta.title ? window.$T(to.meta.title) + ' : ' + title + ' - commin' : title;
    } else if (community) {
      document.title = to.meta.title ? window.$T(to.meta.title) + ' : ' + community.name + ' - commin' : 'commin';
    } else {
      document.title = to.meta.title ? window.$T(to.meta.title) + ' - commin' : 'commin';
    }
  },
  setDocumentTitleWithFreeWord(word, id) {
    var c = id ? store.state.community.communityMap[id] : false;
    if (c) {
      document.title = word + ' : ' + c.name + ' - commin';
    } else {
      document.title = word + ' - commin';
    }
  },
  roles: {
    1: $T('common.role.administrator'),
    2: $T('common.role.manager'),
    3: $T('common.role.member'),
    4: $T('common.role.guest'),
  },
  role(v) {
    return this.roles[v];
  },
  status(v, role) {
    if (v == 1) return this.role(role);
    if (v == 2) return $T('common.member_status.pending');
    if (v == 9) return $T('common.member_status.denied');
    if (v == 10) return $T('common.member_status.retired');
    if (v == 99) return $T('common.member_status.banned');
    return 'UNKNOWN';
  },
  isFriendStatusActive(v, role) {
    return CONST.FRIEND_STATUS.ACTIVE == v;
  },
  friendStatus(v, role) {
    if (v == 1) return $T('common.friend_status.active');
    if (v == 2) return $T('common.friend_status.request');
    if (v == 3) return $T('common.friend_status.beRequested');
    if (v == 4) return $T('common.friend_status.refuse');
    if (v == 5) return $T('common.friend_status.beRefused');
    if (v == 6) return $T('common.friend_status.cancel');
    if (v == 7) return $T('common.friend_status.beCanceled');
    if (v == 8) return $T('common.friend_status.ban');
    if (v == 9) return $T('common.friend_status.beBanned');
    return 'UNKNOWN';
  },
  toYyyyMm(yyyymm) {
    let m = yyyymm % 100;
    if (m == 0) {
      return yyyymm - 100 + 12;
    }
    if (m == 13) {
      return yyyymm + 100 - 12;
    }
    return yyyymm;
  },
  getSizeFromSize(wh, size, pixelRatio, defaultSize, useMin) {
    if (!wh) {
      return defaultSize;
    }
    var deviceSize = size * pixelRatio;
    var whs = this.sortWh(wh, useMin);
    if (pixelRatio == 1) {
      for (var wh of whs) {
        if (wh.v >= deviceSize) return wh.k;
      }
    } else {
      for (var i = 0, n = whs.length - 1; i < n; i++) {
        if ((whs[i].v + whs[i + 1].v) / 2 >= deviceSize) return whs[i].k;
      }
    }
    return whs[whs.length - 1].k;
  },
  sortWh(wh, useMin) {
    var whs = [];
    for (var key in wh) {
      whs.push({ k: key, v: useMin ? Math.min(wh[key][0], wh[key][1]) : wh[key][0] });
    }
    whs.sort((a, b) => {
      return a.v < b.v ? -1 : 1;
    });
    return whs;
  },
  postCodeToIcon(code) {
    switch (code) {
      case 'JA':
        return 'mdi-account-check';
      case 'FA':
        return 'mdi-account-check';
      case 'JI':
        return 'mdi-account-card-details-outline';
      case 'FI':
        return 'mdi-account-check';
      case 'NS':
        return 'mdi-comment-text-outline';
      case 'FL':
        return 'mdi-file-outline';
      case 'SD':
        return 'mdi-calendar-check';
      case 'EQ':
        return 'mdi-format-list-checks';
      case 'LF':
        return 'mdi-heart-outline';
    }
    console.error(`unknown type ${code}`);
    return 'mdi-help';
  },
  postCodeToName(code) {
    switch (code) {
      case 'JA':
      case 'FA':
      case 'JI':
      case 'FI':
        return '';
      case 'NS':
        return $T('post.news.title');
      case 'FL':
        return $T('post.file.title');
      case 'SD':
        return $T('post.schedule.title');
      case 'EQ':
        return $T('post.enquete.title');
      case 'LF':
        return $T('post.life.title');
    }
    console.error(`unknown type ${code}`);
    return 'UNKNOWN';
  },
  postToTitle(post) {
    if (!post) return '';
    if (post.content.main) return post.content.main;
    return this.postCodeToName(post.type);
  },
  toGB(v) {
    var tmp = Math.round(v / ((1024 * 1024 * 1024) / 10));
    return this.addComma(tmp / 10 + (tmp % 10 ? 'GB' : '.0GB'));
  },
  toFileSize(v) {
    if (v < 512) {
      // lower than 0.5KB
      return v + 'B';
    }
    if (v < 512 * 1024) {
      // lower than 0.5MB
      var tmp = Math.round(v / (1024 / 10));
      return this.addComma(tmp / 10 + (tmp % 10 ? 'KB' : '.0KB'));
    }
    if (v < 512 * 1024 * 1024) {
      // lower than 0.5GB
      var tmp = Math.round(v / ((1024 * 1024) / 10));
      return this.addComma(tmp / 10 + (tmp % 10 ? 'MB' : '.0MB'));
    }
    return toGB(v);
  },
  addComma(v) {
    return String(v).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  },
  toMapUrl(loc) {
    return `https://maps.google.co.jp/maps/search/${encodeURIComponent(loc)}?hl=${this.userLang}`;
  },
  saveTalkMsgToCache(tid, msg) {
    var num = msg.num;
    var i = Math.floor(msg.num / 100);
    var cacheKey = `msgs-${tid}-${i}`;
    $commin.clientdb.getObject(cacheKey, function(data) {
      var k = `m${num}`;
      if (!data) data = {};
      var d = data[k];
      if (!d) d = {};
      d[`c${msg.cmid}`] = msg;
      data[k] = d;
      $commin.clientdb.putObject(cacheKey, data);
    });
  },
  saveReadToCache(tid, read) {
    var cacheKey = `talk-mems-${tid}`;
    $commin.clientdb.getObject(cacheKey, function(data) {
      if (!data) data = {};
      data.read = read;
      $commin.clientdb.putObject(cacheKey, data);
    });
  },
  getCommunity(communityId) {
    return store.state.community.communityMap[communityId];
  },
  getAllGroupsAndMembers(cid, cb, forceUpdate) {
    var commit = store.commit;
    if (cid == store.state.community.fcid) {
      var at = store.state.community.friendUpdatedTime;
      if (forceUpdate) return commit('COM_UPDATE_FRIEND', { at: at, cb: cb });

      var key = `groups-members-${cid}`;
      var self = this;
      $commin.clientdb.getObject(key, function(data) {
        if (data) {
          if (at == data.mat && at == data.gat) return cb(data);
        }
        commit('COM_UPDATE_FRIEND', { cid: cid, cb: cb });
      });
    } else {
      if (forceUpdate) return commit('COM_UPDATE_MEMBER', { cid: cid, cb: cb, commit: commit });

      var key = `groups-members-${cid}`;
      var self = this;
      $commin.clientdb.getObject(key, function(data) {
        if (data) {
          var c = self.getCommunity(cid);
          // c（communityMap[cid]）が未ロード/不一致だと undefined になり得る（古いclientdbキャッシュ等）。
          // ガードして再取得にフォールバック（member_changed_at 読取の TypeError 防止）。
          if (c && c.member_changed_at == data.mat && c.group_changed_at == data.gat) return cb(data);
        }
        commit('COM_UPDATE_MEMBER', { cid: cid, cb: cb, commit: commit });
      });
    }
  },
  getInactiveMembers(cid, cb, forceUpdate) {
    var commit = store.commit;
    if (cid == store.state.community.fcid) {
      var at = store.state.community.friendUpdatedTime;
      if (forceUpdate) return commit('COM_UPDATE_FRIEND', { at: at, inactiveCb: cb });

      var key = `inacitve-members-${cid}`;
      var self = this;
      $commin.clientdb.getObject(key, function(data) {
        if (data) {
          if (at == data.mat && at == data.gat) return cb(data);
        }
        commit('COM_UPDATE_FRIEND', { cid: cid, inactiveCb: cb });
      });
    } else {
      if (forceUpdate) return commit('COM_UPDATE_INACTIVE_MEMBER', { cid: cid, cb: cb, commit: commit });

      var key = `inacitve-members-${cid}`;
      var self = this;
      $commin.clientdb.getObject(key, function(data) {
        if (data) {
          var c = self.getCommunity(cid);
          // 同上: c 未定義時のクラッシュを防ぎ再取得にフォールバック。
          if (c && c.member_changed_at == data.mat) return cb(data);
        }
        commit('COM_UPDATE_INACTIVE_MEMBER', { cid: cid, cb: cb, commit: commit });
      });
    }
  },
  getPeriodLabels() {
    return [
      { value: 1, label: $T('common.month_one') },
      { value: 3, label: $T('common.months', { n: 3 }) },
      { value: 6, label: $T('common.months', { n: 6 }) },
      { value: 12, label: $T('common.months', { n: 12 }) },
    ];
  },
  isPostCompleted(post) {
    return (
      !post.is_member ||
      !!post.answered ||
      !!post.completed_at ||
      (post.expire_at && post.expire_at < new Date().getTime() / 1000)
    );
  },
  mergePost(posts, post) {
    if (!posts || posts.length == 0) return [post];
    if (post.post_at > posts[0].post_at) {
      posts.unshift(post);
      return posts;
    }
    var updated = false;
    for (var i = 0, n = posts.length; i < n; i++) {
      if (post.id == posts[i].id) {
        posts[i] = post;
        return posts;
      }
      if (i == 0) continue;
      if (posts[i - 1].post_at > post.post_at && post.post_at >= posts[i].post_at) {
        posts.splice(i, 0, post);
        return posts;
      }
    }
    posts.push(post);
    return posts;
  },
  removePost(posts, pid) {
    if (!posts || posts.length == 0) return [];
    var updated = false;
    for (var i = 0, n = posts.length; i < n; i++) {
      if (pid == posts[i].id) {
        posts.splice(i, 1);
        break;
      }
    }
    return posts;
  },

  removeSpace(tgt) {
    if (!tgt) return '';
    tgt = tgt.replace(/\r?\n/g, '');
    tgt = tgt.replace(/[ 　]+/g, '').trim();
    return tgt;
  },
};
